import React, { useState } from "react"
import {
  ShoppingCart,
  Plus,
  Minus,
  Trash2,
  CreditCard,
  DollarSign,
  Smartphone,
  Send,
  CheckCircle,
} from "lucide-react"
import "./CoffeeOrderingApp.css"

const CoffeeOrderingApp = () => {
  const [cart, setCart] = useState([])
  const [showCart, setShowCart] = useState(false)
  const [showCheckout, setShowCheckout] = useState(false)
  const [orderSubmitted, setOrderSubmitted] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState("coffee")
  const [customerInfo, setCustomerInfo] = useState({ name: "", email: "", phone: "" })
  const [orderNumber, setOrderNumber] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)
  const [showFlavorModal, setShowFlavorModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [showSizeModal, setShowSizeModal] = useState(false)

  const ORDER_WEBHOOK_URL = process.env.REACT_APP_RUGAS_ORDER_WEBHOOK_URL || ""
  const ORDER_EMAIL = process.env.REACT_APP_RUGAS_ORDER_EMAIL || "orders@rugascafe.com"
  const FORMSPREE_ENDPOINT = process.env.REACT_APP_RUGAS_FORMSPREE_ENDPOINT || ""

  const menu = {
    breakfast: [
      { id: "b1", name: "Ruga's Big Breakfast", description: "Barossa free range eggs, bacon, chorizo, hash brown, grilled mushrooms & cherry tomatoes w/ ciabatta toast", price: 22.9, category: "breakfast", image: "🍳" },
      { id: "b2", name: "Eggs Your Way", description: "Barossa free range eggs poached, sunny-side-up or scrambled w/ ciabatta toast", price: 12.9, category: "breakfast", image: "🥚" },
      { id: "b3", name: "The Australian Omelette", description: "Ham, cheese, tomato & onion", price: 16.9, category: "breakfast", image: "🍳" },
      { id: "b4", name: "The Italian Omelette", description: "Salami, sun dried tomatoes, onion & spinach", price: 16.9, category: "breakfast", image: "🍳" },
      { id: "b5", name: "The Vego Omelette", description: "Tomato, mushroom, spinach & cheese", price: 16.9, category: "breakfast", image: "🍳" },
      { id: "b6", name: "Ruga's Smashed Avo", description: "Ciabatta toast w/ smashed avo, crumbed fetta & balsamic glaze", price: 13.9, category: "breakfast", image: "🥑" },
      { id: "b7", name: "Brekky Wrap", description: "Bacon, egg, Old English cheese, jalapenos, spinach, avocado, hash brown & peri peri mayo", price: 14.9, category: "breakfast", image: "🌯" },
      { id: "b8", name: "Ruga's BS Roll", description: "Bacon, egg, Old English cheese, grilled tomato & peri peri mayo", price: 9.9, category: "breakfast", image: "🥖" },
      { id: "b9", name: "The Boss Roll", description: "Bacon, egg, spinach, fetta, avocado & peri peri mayo", price: 10.9, category: "breakfast", image: "🥖" },
      { id: "b10", name: "Johnny Princess Roll", description: "Bacon, egg, spinach, avocado, red onion, tomato, Old English cheese, hash brown & hollandaise sauce", price: 13.9, category: "breakfast", image: "🥖" },
      { id: "b11", name: "Bacon & Egg Roll", description: "", price: 8.9, category: "breakfast", image: "🥖" },
      { id: "b12", name: "Bacon & Egg Sandwich", description: "", price: 7.9, category: "breakfast", image: "🥪" },
      { id: "b13", name: "Ciabatta Toast (2 pieces)", description: "", price: 6.9, category: "breakfast", image: "🍞" },
      { id: "b14", name: "Fruit Toast (2 pieces)", description: "", price: 7.9, category: "breakfast", image: "🍞" },
      { id: "b15", name: "Muesli & Yoghurt Bowl", description: "", price: 11.9, category: "breakfast", image: "🥣" },
    ],
    coffee: [
      { id: "c1", name: "Espresso", description: "Single shot", price: { small: 3.5, medium: 4.0, large: 4.5 }, category: "coffee", image: "☕" },
      { id: "c2", name: "Double Espresso", description: "Double shot", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
      { id: "c3", name: "Long Black", description: "Espresso with hot water", price: { small: 4.0, medium: 4.5, large: 5.0 }, category: "coffee", image: "☕" },
      { id: "c4", name: "Short Black", description: "Single espresso shot", price: { small: 3.5, medium: 4.0, large: 4.5 }, category: "coffee", image: "☕" },
      { id: "c5", name: "Flat White", description: "Espresso with velvety microfoam", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
      { id: "c6", name: "Cappuccino", description: "Espresso with steamed milk & foam", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
      { id: "c7", name: "Latte", description: "Espresso with steamed milk", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
      { id: "c8", name: "Mocha", description: "Espresso with chocolate & milk", price: { small: 5.0, medium: 5.5, large: 6.0 }, category: "coffee", image: "☕" },
      { id: "c9", name: "Macchiato", description: "Espresso with milk foam", price: { small: 4.0, medium: 4.5, large: 5.0 }, category: "coffee", image: "☕" },
      { id: "c10", name: "Piccolo", description: "Ristretto with steamed milk", price: { small: 4.0, medium: 4.5, large: 5.0 }, category: "coffee", image: "☕" },
      { id: "c11", name: "Affogato", description: "Espresso over vanilla ice cream", price: { small: 6.5, medium: 7.0, large: 7.5 }, category: "coffee", image: "🍨" },
      { id: "c12", name: "Hot Chocolate", description: "Rich chocolate with steamed milk", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
      { id: "c13", name: "Chai Latte", description: "Spiced tea with steamed milk", price: { small: 4.5, medium: 5.0, large: 5.5 }, category: "coffee", image: "☕" },
    ],
    sandwiches: [
      { id: "s1", name: "B.L.T.", description: "Bacon, lettuce, tomato & mayo", price: 6.5, category: "sandwiches", image: "🥪" },
      { id: "s2", name: "Meatlovers", description: "Chicken, bacon, salami, cheese, onion & BBQ sauce", price: 7.9, category: "sandwiches", image: "🥪" },
      { id: "s3", name: "Mediterranean", description: "Salami, roasted capsicum, fetta & olives", price: 7.5, category: "sandwiches", image: "🥪" },
      { id: "s4", name: "Chicken Combo", description: "Chicken or chicken tenders, bacon, cheese, tomato, lettuce & mayo", price: 7.9, category: "sandwiches", image: "🥪" },
      { id: "s5", name: "Cajun Chicken", description: "Chicken, avocado, roasted capsicum, spinach & peri peri", price: 7.9, category: "sandwiches", image: "🥪" },
      { id: "s6", name: "Sweet Chilli Chicken", description: "Chicken, cheese, avocado, tomato, lettuce & mayo", price: 7.5, category: "sandwiches", image: "🥪" },
      { id: "s7", name: "Vego", description: "Cheese, avocado, spinach & roast vegetables", price: 6.9, category: "sandwiches", image: "🥪" },
    ],
    drinks: [
      { id: "d1", name: "Milkshakes", description: "Chocolate / banana / strawberry / vanilla / caramel", price: 8.0, category: "drinks", image: "🥤" },
      { id: "d2", name: "Thickshakes", description: "Chocolate / banana / strawberry / vanilla / caramel", price: 9.0, category: "drinks", image: "🥤" },
      { id: "d3", name: "Deluxe Milkshakes", description: "Snickers / banana choc chip", price: 8.5, category: "drinks", image: "🥤" },
      { id: "d4", name: "Deluxe Thickshakes", description: "Snickers / banana choc chip", price: 9.5, category: "drinks", image: "🥤" },
      { id: "d5", name: "Home-made Iced Coffee", description: "Cream add $0.50", price: 8.0, category: "drinks", image: "☕" },
      { id: "d6", name: "Home-made Iced Chocolate", description: "Cream add $0.50", price: 8.0, category: "drinks", image: "☕" },
    ],
    smoothies: [
      { id: "sm1", name: "Ruga's Special", description: "Banana, berries, oats, yoghurt & milk", price: 10.5, category: "smoothies", image: "🥤" },
      { id: "sm2", name: "Banana & Mango", description: "Banana, mango, mango nectar & yoghurt", price: 10.5, category: "smoothies", image: "🥤" },
      { id: "sm3", name: "Apple Berry", description: "Mixed berries, apple juice & yoghurt", price: 10.5, category: "smoothies", image: "🥤" },
    ],
    juices: [
      { id: "j1", name: "Pink Lady", description: "Apples, watermelon, strawberries & mixed berries", price: 9.5, category: "juices", image: "🧃" },
      { id: "j2", name: "Gone Troppo", description: "Banana, pineapple, orange, mango", price: 9.5, category: "juices", image: "🧃" },
      { id: "j3", name: "Kick Start", description: "Apple, orange, kiwi fruit & carrot", price: 9.5, category: "juices", image: "🧃" },
    ],
  }

  const categories = [
    { id: "coffee", name: "Coffee", icon: "☕" },
    { id: "breakfast", name: "Breakfast", icon: "🍳" },
    { id: "sandwiches", name: "Sandwiches", icon: "🥪" },
    { id: "drinks", name: "Drinks", icon: "🥤" },
    { id: "smoothies", name: "Smoothies", icon: "🥤" },
    { id: "juices", name: "Fresh Juices", icon: "🧃" },
  ]

  const addToCart = (product, flavor = null, size = null) => {
    let finalProduct = { ...product }

    if (size && typeof product.price === "object") {
      finalProduct = {
        ...product,
        name: `${product.name} (${size})`,
        price: product.price[size.toLowerCase()],
        size,
        id: `${product.id}-${size.toLowerCase()}`,
      }
    }

    if (flavor) {
      finalProduct = {
        ...finalProduct,
        name: `${finalProduct.name.split(" (")[0]} (${flavor})`,
        flavor,
        id: `${product.id}-${flavor.toLowerCase()}`,
      }
    }

    const existingItem = cart.find((item) => item.id === finalProduct.id)
    if (existingItem) {
      setCart(cart.map((item) => (item.id === finalProduct.id ? { ...item, quantity: item.quantity + 1 } : item)))
    } else {
      setCart([...cart, { ...finalProduct, quantity: 1 }])
    }

    setShowFlavorModal(false)
    setShowSizeModal(false)
    setSelectedProduct(null)
  }

  const handleAddToCart = (product) => {
    if (product.category === "coffee" && typeof product.price === "object") {
      setSelectedProduct(product)
      setShowSizeModal(true)
      return
    }

    if (product.name.includes("Milkshakes") || product.name.includes("Thickshakes")) {
      setSelectedProduct(product)
      setShowFlavorModal(true)
      return
    }

    addToCart(product)
  }

  const updateQuantity = (id, change) => {
    setCart(
      cart
        .map((item) => (item.id === id ? { ...item, quantity: Math.max(0, item.quantity + change) } : item))
        .filter((item) => item.quantity > 0)
    )
  }

  const removeFromCart = (id) => setCart(cart.filter((item) => item.id !== id))
  const getTotal = () => cart.reduce((sum, item) => sum + item.price * item.quantity, 0).toFixed(2)

  const sendOrderToWebhook = async (orderDetails) => {
    try {
      const response = await fetch(ORDER_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderDetails),
      })
      return response.ok
    } catch {
      return false
    }
  }

  const sendOrderToFormspree = async (orderDetails) => {
    try {
      const emailBody = `
NEW ORDER #${orderDetails.orderNumber}

Customer Information:
- Name: ${orderDetails.customer.name}
- Email: ${orderDetails.customer.email}
- Phone: ${orderDetails.customer.phone}

Order Items:
${orderDetails.items.map((item) => `- ${item.name} x${item.quantity} = ${(item.price * item.quantity).toFixed(2)}`).join("\n")}

Total: ${orderDetails.total}
Payment Method: ${orderDetails.paymentMethod}
Order Time: ${new Date(orderDetails.timestamp).toLocaleString()}
      `

      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: orderDetails.customer.email,
          subject: `New Ruga's Cafe Order #${orderDetails.orderNumber}`,
          message: emailBody,
          orderNumber: orderDetails.orderNumber,
          customerName: orderDetails.customer.name,
          customerEmail: orderDetails.customer.email,
          customerPhone: orderDetails.customer.phone,
          orderTotal: orderDetails.total,
          paymentMethod: orderDetails.paymentMethod,
          items: JSON.stringify(orderDetails.items),
        }),
      })

      return response.ok
    } catch {
      return false
    }
  }

  const handlePayment = async (paymentMethod) => {
    if (!customerInfo.name || !customerInfo.email || !customerInfo.phone) {
      alert("Please fill in all customer information")
      return
    }

    setIsProcessing(true)
    const newOrderNumber = Math.floor(100000 + Math.random() * 900000)

    const orderDetails = {
      orderNumber: newOrderNumber,
      items: cart,
      total: getTotal(),
      paymentMethod,
      customer: customerInfo,
      timestamp: new Date().toISOString(),
      status: "pending",
    }

    try {
      await new Promise((resolve) => setTimeout(resolve, 900))

      if (FORMSPREE_ENDPOINT && FORMSPREE_ENDPOINT !== "YOUR_FORMSPREE_ENDPOINT_HERE") {
        await sendOrderToFormspree(orderDetails)
      }

      if (ORDER_WEBHOOK_URL && ORDER_WEBHOOK_URL !== "YOUR_WEBHOOK_URL_HERE") {
        await sendOrderToWebhook(orderDetails)
      }

      setOrderNumber(newOrderNumber)
      setOrderSubmitted(true)
      setIsProcessing(false)

      setTimeout(() => {
        setCart([])
        setShowCheckout(false)
        setOrderSubmitted(false)
        setShowCart(false)
        setCustomerInfo({ name: "", email: "", phone: "" })
      }, 3000)
    } catch {
      alert("There was an error processing your order. Please try again.")
      setIsProcessing(false)
    }
  }

  if (orderSubmitted) {
    return (
      <div className="coffee-page">
        <div className="coffee-confirm-card">
          <CheckCircle className="coffee-confirm-icon" />
          <h2 className="coffee-confirm-title">Order Confirmed!</h2>
          <p className="coffee-confirm-sub">Order #{orderNumber}</p>
          <p className="coffee-confirm-sub2">A confirmation has been sent to {customerInfo.email}</p>
          <div className="coffee-confirm-emoji">☕</div>
          <p className="coffee-confirm-footer">Your order is being prepared at Ruga&apos;s Cafe</p>
        </div>
      </div>
    )
  }

  if (showSizeModal && selectedProduct) {
    const sizes = ["Small", "Medium", "Large"]

    return (
      <div className="coffee-modal">
        <div className="coffee-modal-card">
          <h2 className="coffee-modal-title">Choose Your Size</h2>
          <p className="coffee-modal-sub">{selectedProduct.name}</p>

          <div className="coffee-modal-options">
            {sizes.map((size) => (
              <button key={size} onClick={() => addToCart(selectedProduct, null, size)} className="coffee-modal-option">
                <span className="coffee-modal-option-left">{size}</span>
                <span className="coffee-modal-option-right">${selectedProduct.price[size.toLowerCase()].toFixed(2)}</span>
              </button>
            ))}
          </div>

          <button
            onClick={() => {
              setShowSizeModal(false)
              setSelectedProduct(null)
            }}
            className="coffee-modal-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    )
  }

  if (showFlavorModal && selectedProduct) {
    const flavors = ["Chocolate", "Banana", "Strawberry", "Vanilla", "Caramel"]

    return (
      <div className="coffee-modal">
        <div className="coffee-modal-card">
          <h2 className="coffee-modal-title">Choose Your Flavor</h2>
          <p className="coffee-modal-sub">{selectedProduct.name}</p>

          <div className="coffee-modal-options">
            {flavors.map((flavor) => (
              <button key={flavor} onClick={() => addToCart(selectedProduct, flavor)} className="coffee-modal-option">
                <span className="coffee-modal-option-left">{flavor}</span>
              </button>
            ))}
          </div>

          <button
            onClick={() => {
              setShowFlavorModal(false)
              setSelectedProduct(null)
            }}
            className="coffee-modal-cancel"
          >
            Cancel
          </button>
        </div>
      </div>
    )
  }

  if (showCheckout) {
    return (
      <div className="coffee-page">
        <div className="coffee-container">
          <button onClick={() => setShowCheckout(false)} className="coffee-back">
            ← Back to Cart
          </button>

          <div className="coffee-card">
            <h2 className="coffee-h2">Checkout</h2>

            <div className="coffee-section">
              <h3 className="coffee-h3">Order Summary</h3>
              {cart.map((item) => (
                <div key={item.id} className="coffee-row">
                  <span className="coffee-row-left">
                    {item.name} x{item.quantity}
                  </span>
                  <span className="coffee-row-right">${(item.price * item.quantity).toFixed(2)}</span>
                </div>
              ))}
              <div className="coffee-total">
                <span>Total</span>
                <span className="coffee-total-amt">${getTotal()}</span>
              </div>
            </div>

            <div className="coffee-section">
              <h3 className="coffee-h3">Customer Information</h3>
              <div className="coffee-fields">
                <input
                  type="text"
                  placeholder="Full Name *"
                  value={customerInfo.name}
                  onChange={(e) => setCustomerInfo({ ...customerInfo, name: e.target.value })}
                  className="coffee-input"
                />
                <input
                  type="email"
                  placeholder="Email *"
                  value={customerInfo.email}
                  onChange={(e) => setCustomerInfo({ ...customerInfo, email: e.target.value })}
                  className="coffee-input"
                />
                <input
                  type="tel"
                  placeholder="Phone Number *"
                  value={customerInfo.phone}
                  onChange={(e) => setCustomerInfo({ ...customerInfo, phone: e.target.value })}
                  className="coffee-input"
                />
              </div>
            </div>

            <div className="coffee-section">
              <h3 className="coffee-h3">Order Destination</h3>
              <div className="coffee-destination">
                <Send className="coffee-destination-icon" size={18} />
                <div className="coffee-destination-text">
                  <p className="coffee-destination-title">Your order will be sent to:</p>
                  <ul className="coffee-destination-list">
                    <li>
                      ✉️ Email: <span className="coffee-mono">{ORDER_EMAIL}</span>
                    </li>
                    <li>🔗 Webhook for order processing</li>
                    <li>💾 Stored in browser for your records</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="coffee-section">
              <h3 className="coffee-h3">Payment Method</h3>

              <div className="coffee-pay">
                <button onClick={() => handlePayment("Credit Card")} disabled={isProcessing} className="coffee-pay-btn coffee-pay-primary">
                  <CreditCard size={20} />
                  <span>{isProcessing ? "Processing..." : "Pay with Credit Card"}</span>
                </button>

                <button onClick={() => handlePayment("Debit Card")} disabled={isProcessing} className="coffee-pay-btn coffee-pay-dark">
                  <CreditCard size={20} />
                  <span>{isProcessing ? "Processing..." : "Pay with Debit Card"}</span>
                </button>

                <button onClick={() => handlePayment("Mobile Payment")} disabled={isProcessing} className="coffee-pay-btn coffee-pay-neutral">
                  <Smartphone size={20} />
                  <span>{isProcessing ? "Processing..." : "Mobile Payment"}</span>
                </button>

                <button onClick={() => handlePayment("Cash")} disabled={isProcessing} className="coffee-pay-btn coffee-pay-outline">
                  <DollarSign size={20} />
                  <span>{isProcessing ? "Processing..." : "Pay with Cash"}</span>
                </button>
              </div>

              {!FORMSPREE_ENDPOINT ? (
                <div className="coffee-note">Missing REACT_APP_RUGAS_FORMSPREE_ENDPOINT. Orders will not email yet.</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (showCart) {
    return (
      <div className="coffee-page">
        <div className="coffee-container">
          <button onClick={() => setShowCart(false)} className="coffee-back">
            ← Continue Shopping
          </button>

          <div className="coffee-card">
            <h2 className="coffee-h2">Your Cart</h2>

            {cart.length === 0 ? (
              <div className="coffee-empty">
                <div className="coffee-empty-emoji">🛒</div>
                <p className="coffee-empty-text">Your cart is empty</p>
              </div>
            ) : (
              <>
                <div className="coffee-cart-list">
                  {cart.map((item) => (
                    <div key={item.id} className="coffee-cart-item">
                      <div className="coffee-cart-emoji">{item.image}</div>
                      <div className="coffee-cart-main">
                        <div className="coffee-cart-name">{item.name}</div>
                        <div className="coffee-cart-price">${item.price.toFixed(2)}</div>
                      </div>

                      <div className="coffee-qty">
                        <button onClick={() => updateQuantity(item.id, -1)} className="coffee-qty-btn" aria-label="Decrease quantity">
                          <Minus size={14} />
                        </button>
                        <span className="coffee-qty-num">{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, 1)} className="coffee-qty-btn" aria-label="Increase quantity">
                          <Plus size={14} />
                        </button>
                      </div>

                      <button onClick={() => removeFromCart(item.id)} className="coffee-remove" aria-label="Remove item">
                        <Trash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="coffee-cart-footer">
                  <div className="coffee-cart-total">
                    <span>Total:</span>
                    <span className="coffee-cart-total-amt">${getTotal()}</span>
                  </div>
                  <button onClick={() => setShowCheckout(true)} className="coffee-checkout">
                    Proceed to Checkout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="coffee-page">
      <div className="coffee-container">
        <header className="coffee-header">
          <div className="coffee-header-left">
            <h1 className="coffee-title">Ruga&apos;s Cafe</h1>
            <p className="coffee-subtitle">Bright coffee. Fresh bakes. Sunny vibes.</p>
          </div>

          <button onClick={() => setShowCart(true)} className="coffee-cart-btn" aria-label="Open cart">
            <ShoppingCart size={22} />
            {cart.length > 0 ? (
              <span className="coffee-badge">{cart.reduce((sum, item) => sum + item.quantity, 0)}</span>
            ) : null}
          </button>
        </header>

        <div className="coffee-cats">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setSelectedCategory(cat.id)}
              className={`coffee-cat ${selectedCategory === cat.id ? "coffee-cat-active" : ""}`}
            >
              {cat.icon} {cat.name}
            </button>
          ))}
        </div>

        <div className="coffee-grid">
          {menu[selectedCategory].map((product) => (
            <div key={product.id} className="coffee-item">
              <div className="coffee-item-emoji">{product.image}</div>
              <div className="coffee-item-body">
                <h3 className="coffee-item-name">{product.name}</h3>
                {product.description ? <p className="coffee-item-desc">{product.description}</p> : null}

                <div className="coffee-item-footer">
                  <span className="coffee-price">
                    {typeof product.price === "object"
                      ? `$${product.price.small.toFixed(2)} - $${product.price.large.toFixed(2)}`
                      : `$${product.price.toFixed(2)}`}
                  </span>

                  <button onClick={() => handleAddToCart(product)} className="coffee-add">
                    <Plus size={18} />
                    Add
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <footer className="coffee-footer">
          Ruga&apos;s Cafe. No substitutes. Public holiday surcharge applies.
        </footer>
      </div>
    </div>
  )
}

export default CoffeeOrderingApp
